import { call, put, takeLatest } from 'redux-saga/effects';

import { savePropertyObjectTitle } from '../../services/API';
import { actionTypes, requestFailure, requestSuccess } from './actions';

function* saveData({ payload: { id, data } }) {
  const response = yield call(savePropertyObjectTitle, id, data);
  yield put(response.isOk ? requestSuccess(response.data) : requestFailure(response.error));
}

export default function* propertyObjectTitleSaga() {
  yield takeLatest(actionTypes.REQUEST_START, saveData);
}
